<template>
  <div
    class="footer"
    :class="{
      en: $i18n.locale === 'en-US',
    }"
  >
    <div class="footer-main">
      <div class="footer-content">
        <!-- 产品中心 -->
        <div class="products">
          <div class="title section-title">
            {{ i18n.productCenter }}
          </div>
          <div class="group-wrapper section-subtitle flex">
            <div class="group left">
              <router-link
                v-for="(item, index) in products.groupLeft"
                :key="index"
                :to="item.path"
                class="link"
                v-html="$t('header.menu.' + item.key)"
                ></router-link
              >
            </div>
            <div class="group right">
              <router-link
                v-for="(item, index) in products.groupRight"
                :key="index"
                :to="item.path"
                class="link"
                v-html="$t('header.menu.' + item.key)"
                ></router-link
              >
            </div>
          </div>
        </div>
        <!-- 联系我们 -->
        <div class="contact">
          <div class="title section-title">
            {{ i18n.contectUs }}
          </div>
          <div class="info section-subtitle">
            <div class="item">
              <img class="item-icon" src="@/static/img/tel.svg" alt="" />
              <span class="item-text">021-69585189；0574-86559375</span>
            </div>
            <div class="item">
              <img class="item-icon" src="@/static/img/Mail.svg" alt="" />
              <span class="item-text"
                >{{ i18n.business }}：contact@pd-automotive.com</span
              >
            </div>
            <div class="item">
              <img class="item-icon" src="@/static/img/Mail.svg" alt="" />
              <span class="item-text"
                >{{ i18n.media }}：pr@pd-automotive.com</span
              >
            </div>
            <div class="item">
              <img class="item-icon" src="@/static/img/Mail.svg" alt="" />
              <span class="item-text">{{ i18n.hr }}：hr@pd-automotive.com</span>
            </div>
            <div class="item">
              <img class="item-icon" src="@/static/img/position.svg" alt="" />
              <span class="item-text">{{ i18n.address1 }}</span>
            </div>
            <div class="item">
              <img class="item-icon" src="@/static/img/position.svg" alt="" />
              <span class="item-text">{{ i18n.address2 }}</span>
            </div>
          </div>
        </div>
        <!-- logo and qrcode -->
        <div class="logo-and-qrcode flex column">
          <img class="logo" src="@/static/img/logo.png" alt="logo" />
          <div class="qrcode-wrapper flex items-center">
            <img
              src="@/static/img/TwoDimensionalCode.png"
              alt=""
              class="qrcode"
            />
            <div class="follow-wrapper section-subtitle">
              <p>{{ i18n.followUs }}</p>
              <p>{{ i18n.simulationWorld }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright flex items-center justify-center">
      <a
        href="https://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
      >
        © 沛岱（上海）汽车技术有限公司 沪ICP备17045473号-1 &nbsp; &nbsp;
        版权所有：沛岱（上海）汽车技术有限公司
      </a>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      products: {
        groupLeft: [
          { key: "PDGaiA", path: "/productGaiA" },
          { key: "PDRobot", path: "/productRobot" },
          { key: "PDUranus", path: "/productUranus" },
          { key: "OnCloud", path: "/productClound" },
          { key: "PDRHea", path: "/productRHea" },
        ],
        groupRight: [
          { key: "PlenRay", path: "/coretechnology" },
          { key: "DiL", path: "/productRing" },
          { key: "Medusa", path: "/productMedusa" },
          { key: "Hercules", path: "/productHercules" },
        ],
      },
    };
  },
  computed: {
    i18n() {
      return this.$t("footer");
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;

  .footer-main {
    width: 100%;
    padding: 3rem 0;
    display: flex;
    background: #070a16 url("@/static/img/footerbg.png") no-repeat center 20%;
    background-size: cover;
    .footer-content {
      width: 71.841rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
    .section-title {
      font-size: 1rem;
      font-weight: 500;
      line-height: normal;
      margin-bottom: 2rem;
    }
    .section-subtitle {
      font-size: 0.75rem;
      line-height: normal;
    }
    // 产品中心
    .products {
      width: 34.6875rem;
      .group-wrapper {
        width: 100%;
        .group {
          width: 50%;
          padding-right: 1.5625rem;
          .link {
            display: block;
            color: inherit;
            text-decoration: none;
            margin-bottom: 1rem;
            &:hover {
              color: #d71f28;
            }
          }
        }
      }
    }

    // 联系我们
    .contact {
      width: 20.4rem;
      margin-right: 2.875rem;
      .info {
        .item {
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
          .item-icon {
            width: 0.75rem;
            height: 0.75rem;
            margin-right: 0.5rem;
          }
        }
      }
    }

    .logo-and-qrcode {
      // width: 17.5rem;
      width: 15rem; // 为了左侧产品中心和联系我们不换行，这里调小了一点
      margin-right: -1rem;
      margin-top: -0.47rem;
      box-sizing: border-box;

      .logo {
        width: 8.9375rem;
        height: 3.1875rem;
        object-fit: cover;
      }

      .qrcode-wrapper {
        margin-left: 1.5625rem;
        margin-top: 7rem;

        .qrcode {
          width: 5rem;
          height: 5rem;
          object-fit: cover;
        }

        .follow-wrapper {
          margin-left: 0.75rem;
          p {
            font-size: 0.75rem;
            line-height: 1.375rem;
          }
        }
      }
    }
  }

  .copyright {
    width: 100%;
    height: 4rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    background: #070a16;
    a {
      color: rgba(255, 255, 255, 0.45);
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
}
</style>
